define( [
	"../core",
	"../event"
], function( jQuery ) {

"use strict";

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/event/ajax.js
// module id = 1018
// module chunks = 0